import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: BASE });

// ---- client id (identifies this browser's investor) ----
export function getClientId() {
  let id = localStorage.getItem('af_client_id');
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `c_${Date.now()}_${Math.random().toString(16).slice(2)}`;
    localStorage.setItem('af_client_id', id);
  }
  return id;
}

// ---- public / app ----
export const fetchCompanies = () => api.get('/companies').then((r) => r.data);
export const fetchPipeline = () => api.get('/pipeline').then((r) => r.data);
export const startSession = (clientId) => api.post('/users/session', { clientId }).then((r) => r.data);
export const fundUser = (userId, amount) => api.post(`/users/${userId}/fund`, { amount }).then((r) => r.data);
export const verifyKyc = (userId) => api.post(`/users/${userId}/kyc`, {}).then((r) => r.data);
export const submitKyc = (userId, data) => api.post(`/users/${userId}/kyc`, data).then((r) => r.data);
export const buyUserShares = (userId, payload) => api.post(`/users/${userId}/buy`, payload).then((r) => r.data);
export const fetchUser = (userId) => api.get(`/users/${userId}`).then((r) => r.data);

// ---- admin ----
export const adminLogin = (user, password) => api.post('/admin/login', { user, password }).then((r) => r.data);

const adminHeaders = (token) => ({ headers: { 'x-admin-token': token } });

export const adminStats = (token) => api.get('/admin/stats', adminHeaders(token)).then((r) => r.data);
export const adminUsers = (token) => api.get('/admin/users', adminHeaders(token)).then((r) => r.data);
export const adminCompanies = (token) => api.get('/admin/companies', adminHeaders(token)).then((r) => r.data);
export const adminSetKyc = (token, userId, status) => api.post(`/admin/users/${userId}/kyc`, { status }, adminHeaders(token)).then((r) => r.data);
export const adminDeleteUser = (token, userId) => api.delete(`/admin/users/${userId}`, adminHeaders(token)).then((r) => r.data);
export const adminGrant = (token, payload) => api.post('/admin/grant', payload, adminHeaders(token)).then((r) => r.data);
export const adminAddMarket = (token, payload) => api.post('/admin/market', payload, adminHeaders(token)).then((r) => r.data);
export const adminKycSubmissions = (token) => api.get('/admin/kyc', adminHeaders(token)).then((r) => r.data);
export const adminSetPrice = (token, companyId, payload) => api.post(`/admin/company/${companyId}/price`, payload, adminHeaders(token)).then((r) => r.data);
export const adminToggleAutoPrice = (token, companyId, autoPrice) => api.post(`/admin/company/${companyId}/auto-price`, { lastPrice: 1, autoPrice }, adminHeaders(token)).then((r) => r.data);

// ---- crypto deposits ----
export const fetchDepositAddresses = () => api.get('/deposit-addresses').then((r) => r.data);
export const createDeposit = (userId, payload) => api.post(`/users/${userId}/deposit`, payload).then((r) => r.data);
export const fetchUserDeposits = (userId) => api.get(`/users/${userId}/deposits`).then((r) => r.data);
export const adminDepositAddresses = (token) => api.get('/admin/deposit-addresses', adminHeaders(token)).then((r) => r.data);
export const adminSaveDepositAddress = (token, payload) => api.post('/admin/deposit-address', payload, adminHeaders(token)).then((r) => r.data);
export const adminDeposits = (token) => api.get('/admin/deposits', adminHeaders(token)).then((r) => r.data);
export const adminVerifyDeposit = (token, id) => api.post(`/admin/deposits/${id}/verify`, {}, adminHeaders(token)).then((r) => r.data);
export const adminRejectDeposit = (token, id) => api.post(`/admin/deposits/${id}/reject`, {}, adminHeaders(token)).then((r) => r.data);

// ---- auth (email + password accounts) ----
export const authRegister = (payload) => api.post('/auth/register', payload).then((r) => r.data);
export const authLogin = (email, password) => api.post('/auth/login', { email, password }).then((r) => r.data);
export const authMe = (token) => api.get('/auth/me', { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const authForgot = (email, origin) => api.post('/auth/forgot', { email, origin }).then((r) => r.data);
export const authReset = (token, password) => api.post('/auth/reset', { token, password }).then((r) => r.data);
export const authVerify = (token) => api.post('/auth/verify', { token }).then((r) => r.data);

export default api;
